export type UrlToLinkFilter = (date: string) => string | null


/*@ngInject*/
export default function urlToLinkFilter($sanitize): UrlToLinkFilter {

    function generateLink(url: string, text: string) {
        return `<a href="${$sanitize(url)}">${$sanitize(text)}</a>`;
    }

    return (s: string) => {
        if (!s) {
            return null;
        }
        if (s.startsWith('http://') || s.startsWith('https://')) {
            return generateLink(s, s);
        }
        if (s.startsWith('www.')) {
            return generateLink(`http://${s}`, s);
        }
        return s;
    };
}

urlToLinkFilter.filterName = 'urlToLink';
